import React, { FC } from 'react'

import MainModal from './common/MainModal'

import FirestoreService from '../../services/firestoreService'
import useToasterHelper from '../../helpers/ToasterHelper'

import { useAppSelector } from '../../store/hooks'
import { selectProfileData } from '../../store/user/userSlice'

import { ScoreCardModel } from '../../models/score-cards/score-cards.model'
import { IScoreCardInterface } from '../../models/score-cards/score-cards.interface'

import { CONST } from '../../const/const'
import { MODAL_CONSTS } from '../../const/modal-const'
import { MESSAGES_CONST } from '../../const/messages-const'

const COLLECTIONS = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS

interface MakeScoreCardPublicModalProps {
  handleModal: (showHide: boolean, typeOfModal: string, data?: any) => void
  dataToPassOn: { scoreCard: IScoreCardInterface }
}

export const MakeScoreCardPublicModal: FC<MakeScoreCardPublicModalProps> = ({
  handleModal,
  dataToPassOn,
}) => {
  const toastFunctions = useToasterHelper()

  const profileData = useAppSelector(selectProfileData)

  const { scoreCard } = dataToPassOn

  const [loading, setLoading] = React.useState(false)

  const onSubmit = async (isPublic: boolean) => {
    setLoading(true)

    if (!scoreCard?.name) return console.error('Score card is required')

    try {
      if (scoreCard?.id) {
        await FirestoreService.updateItem(
          COLLECTIONS.SCORE_CARDS.NAME,
          scoreCard.id,
          new ScoreCardModel({
            ...scoreCard,
            isPublic,
            modified: new Date().toString(),
          }).toFirestore()
        )
      } else {
        await FirestoreService.createItem(
          COLLECTIONS.SCORE_CARDS.NAME,
          new ScoreCardModel({
            ...scoreCard,
            isPublic,
            owner: profileData.id,
            type: 'hunter-jumper',
          }).toFirestore()
        )
      }
      toastFunctions.success({ message: MESSAGES_CONST.SCORE_CARD_CREATED })
      handleModal?.(false, MODAL_CONSTS.ADD_SCORE_CARD)
      handleModal?.(false, MODAL_CONSTS.MAKE_SCORE_CARD_PUBLIC)
    } catch (e) {
      console.error(e)
      toastFunctions.error({ message: MESSAGES_CONST.SOMETHING_WENT_WRONG })
    } finally {
      setLoading(false)
    }
  }

  return (
    <MainModal
      title="Make public?"
      show={true}
      type="MAKE_SCORE_CARD_PUBLIC"
      size="lg"
      modalClassName={'!z-[50] max-h-[700px]'}
      className="!px-0"
      overlayClassName={'!z-[40]'}
      buttons={[
        {
          label: 'Yes',
          fullWidth: true,
          loading,
          onClick: () => onSubmit(true),
        },
        {
          label: 'No',
          fullWidth: true,
          bgClass: 'bg-SeabiscuitLightThemeColor',
          className: 'outline-none',
          loading,
          borderClass: 'border border-transparent',
          textClass: 'text-SeabiscuitLightTextColor',
          onClick: () => onSubmit(false),
        },
      ]}
    >
      <div className="text-SeabiscuitDark200ThemeColor">
        <p>
          Do you want to make this score card publicly available for other horse show managers to be
          able to use?
        </p>
        <div className="py-10 md:py-20">
          <img
            className="mx-auto w-full max-w-[270px]"
            src="/assets/placeholders/undraw-add-files.svg"
            alt=""
          />
        </div>
      </div>
    </MainModal>
  )
}
